import styled, { css } from 'styled-components'

import { DatePickerProps } from './type'

type DatePickerIconProps = Pick<DatePickerProps, 'heightClass'>

type DatePickerStructureProps = Pick<DatePickerProps, 'heightClass'>

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

export const TimeSelectStructure = styled.div`
  display: table;
  width: 100%;
`

export const DatePickerIcon = styled.button<DatePickerIconProps>`
  appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
  }

  figure {
    ${({ theme, heightClass }) => css`
      width: ${theme.datepicker[heightClass]?.iconSize}px;
    `}
  }
`

export const DatePickerHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 8px;
  padding: 8px;
`

export const DatePickerFooter = styled.div`
  display: flex;
  border-top: 2px solid #abbed1;
  padding: 0.5rem;
  background: white;

  & > div {
    margin-right: 0.5rem;
  }
`

export const DatePickerStructure = styled.div<DatePickerStructureProps>`
  position: absolute;
  align-self: flex-start;
  top: 100%;
  width: 300px;
  border: 2px solid #abbed1;
  border-radius: 0.3rem;
  z-index: 2;

  .react-datepicker {
    width: 100%;
    border: none;

    .react-datepicker__children-container {
      width: auto;
      margin: 0;
      padding: 0;
      height: auto;
    }

    .react-datepicker__header {
      background-color: white;
      padding: 0;

      .react-datepicker__day-names {
        background-color: #abbed1;

        .react-datepicker__day-name {
          color: #303032;
          width: 2.25rem;

          font-size: ${({ theme, heightClass }) =>
            theme.datepicker[heightClass]?.dayFontSize}px;

          font-weight: 600;
        }
      }
    }

    .react-datepicker__month-container {
      float: none;

      .react-datepicker__month {
        .react-datepicker__week {
          .react-datepicker__day {
            width: 2.25rem;

            ${({ theme, heightClass }) => css`
              line-height: ${theme.datepicker[heightClass]?.dayLineHeight}px;
              font-size: ${theme.datepicker[heightClass]?.dayFontSize}px;
            `}
          }

          .react-datepicker__day--outside-month {
            color: #abbed1;
          }

          .react-datepicker__day--selected {
            background-color: #c7deff;
            color: #000;
          }

          .react-datepicker__day--excluded {
            border: 2px dashed #abbed1;
            border-radius: 4px;
          }

          .react-datepicker__day--keyboard-selected {
            border: 2px solid #abbed1;
            border-radius: 4px;
            background-color: #ffffff;
          }
        }
      }
    }
  }
`
